"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositStorage = void 0;
const near_api_js_1 = require("near-api-js");
const config_1 = require("../config/config");
const constants_1 = require("../constants");
const types_1 = require("../types");
/**
 * Deposits 0.01 * listAmount of near to the market contract to be consumed for listing purposes
 * @param depositStorageArguments {@link DepositStorageArgs}
 * @returns contract call to be passed to @mintbase-js/sdk execute method
 */
const depositStorage = (args) => {
    const { marketAddress = config_1.mbjs.keys.marketAddress, listAmount = 1 } = args;
    const deposit = (0.01 * listAmount).toString();
    return {
        contractAddress: marketAddress,
        args: {},
        methodName: types_1.MARKET_METHOD_NAMES.DEPOSIT_STORAGE,
        deposit: near_api_js_1.utils.format.parseNearAmount(deposit),
        gas: constants_1.GAS,
    };
};
exports.depositStorage = depositStorage;
//# sourceMappingURL=depositStorage.js.map